export default [
  {
    path: '/',
    meta: {},
    component: () =>
      import(/* webpackChunkName: "adm" */ '../views/layouts/admin'),
    children: [
      {
        path: '/',
        name: 'landing',
        redirect: '/adm',
        component: () =>
          import(/* webpackChunkName: "landing" */ '../views/layouts/landing'),
        meta: {},
      },
      {
        path: 'verification/:token?',
        name: 'verification',
        component: () =>
          import(
            /* webpackChunkName: "landing" */ '../views/layouts/verification'
          ),
        meta: {},
      },
      {
        path: 'adm',
        name: 'admin',
        meta: {},
        redirect: '/adm/login',
        component: () =>
          import(/* webpackChunkName: "adm" */ '../views/layouts/main'),
        children: [
          {
            path: 'dashboard',
            name: 'adminDashboard',
            meta: {
              modulName: 'admin',
              pageName: 'dashboard',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-dashboard" */ '../views/admin/dashboard'
              ),
          },
          {
            path: 'pabrik',
            name: 'pabrik',
            meta: {
              modulName: 'admin',
              pageName: 'pabrik',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-pabrik" */ '../views/admin/pabrik'
              ),
          },
          {
            path: 'form-pabrik/:id?',
            name: 'formPabrik',
            meta: {
              modulName: 'admin',
              pageName: 'pabrik',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-pabrik" */ '../views/admin/pabrik/form-pabrik'
              ),
          },
          {
            path: 'dept',
            name: 'dept',
            meta: {
              modulName: 'admin',
              pageName: 'dept',
              pageType: 'view',
            },
            component: () =>
              import(/* webpackChunkName: "opr-dept" */ '../views/admin/dept'),
          },
          {
            path: 'jenis-ijin',
            name: 'jenisIjin',
            meta: {
              modulName: 'admin',
              pageName: 'jenisIjin',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-jenis-ijin" */ '../views/admin/jenis-ijin'
              ),
          },
          {
            path: 'print-detail-karyawan/:id?',
            name: 'printDetailKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'karyawan',
              pageType: 'view',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-karyawan" */ '../views/admin/karyawan/print-report-detail'
              ),
          },
          {
            path: 'print-karyawan/:id_pabrik?/:id_dept?/:status?',
            name: 'printKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'karyawan',
              pageType: 'view',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-karyawan" */ '../views/admin/karyawan/print-report'
              ),
          },
          {
            path: 'karyawan',
            name: 'karyawan',
            meta: {
              modulName: 'admin',
              pageName: 'karyawan',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-karyawan" */ '../views/admin/karyawan'
              ),
          },
          {
            path: 'form-karyawan/:id?',
            name: 'formPabrik',
            meta: {
              modulName: 'admin',
              pageName: 'karyawan',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-karyawan" */ '../views/admin/karyawan/form-karyawan'
              ),
          },
          {
            path:
              'print-ijin/:id_karyawan?/:id_pabrik?/:id_dept?/:tgl_awal?/:tgl_akhir?/:status?',
            name: 'printIjin',
            meta: {
              modulName: 'admin',
              pageName: 'ijinKaryawan',
              pageType: 'view',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-karyawan" */ '../views/admin/ijin-karyawan/print-report'
              ),
          },
          {
            path: 'ijin',
            name: 'ijinKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'ijinKaryawan',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-ijin-karyawan" */ '../views/admin/ijin-karyawan'
              ),
          },
          {
            path: 'form-ijin/:id?',
            name: 'formIjinKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'ijinKaryawan',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-ijin-karyawan" */ '../views/admin/ijin-karyawan/form-karyawan'
              ),
          },
          {
            path:
              'print-lembur/:id_karyawan?/:id_pabrik?/:id_dept?/:tgl_awal?/:tgl_akhir?/:status?',
            name: 'printLembur',
            meta: {
              modulName: 'admin',
              pageName: 'lemburKaryawan',
              pageType: 'view',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-karyawan" */ '../views/admin/lembur-karyawan/print-report'
              ),
          },
          {
            path: 'lembur',
            name: 'lemburKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'lemburKaryawan',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-lembur-karyawan" */ '../views/admin/lembur-karyawan'
              ),
          },
          {
            path: 'form-lembur/:id?',
            name: 'formIjinKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'lemburKaryawan',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-lembur-karyawan" */ '../views/admin/lembur-karyawan/form-karyawan'
              ),
          },
          {
            path: 'slip-gaji',
            name: 'slipGaji',
            meta: {
              modulName: 'admin',
              pageName: 'slipGaji',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-slip-gaji" */ '../views/admin/slip-gaji'
              ),
          },
          {
            path: 'slip-gaji/detail/:id_slip_periode',
            name: 'slipGajiPeriode',
            meta: {
              modulName: 'admin',
              pageName: 'slipGajiPeriode',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-slip-gaji-periode" */ '../views/admin/slip-gaji/detail-slip'
              ),
          },
          {
            path: 'print-all-slip/:id_slip_periode?/:id_karyawan?/:id_dept?',
            name: 'printAllSlipGaji',
            meta: {
              modulName: 'admin',
              pageName: 'slipGaji',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-slip-print-gaji" */ '../views/admin/slip-gaji/print-report'
              ),
          },
          {
            path: 'print-slip-periode/:periode?/:id_pabrik?/:status?',
            name: 'printAllSlipPeriode',
            meta: {
              modulName: 'admin',
              pageName: 'slipGaji',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-slip-print-gaji" */ '../views/admin/slip-gaji/print-report-periode'
              ),
          },
          {
            path: 'print-slip-gaji/:id?',
            name: 'printSlipGaji',
            meta: {
              modulName: 'admin',
              pageName: 'slipGaji',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-slip-print-gaji" */ '../views/admin/slip-gaji/print-slip-gaji'
              ),
          },
          {
            path: 'komponen-gaji',
            name: 'kompGaji',
            meta: {
              modulName: 'admin',
              pageName: 'kompGaji',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-komp-gaji" */ '../views/admin/komponen-gaji'
              ),
          },
          {
            path: 'administrator',
            name: 'administrator',
            meta: {
              modulName: 'admin',
              pageName: 'administrator',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-administrator" */ '../views/admin/administrator'
              ),
          },
          {
            path: 'form-administrator/:id?',
            name: 'formAdministrator',
            meta: {
              modulName: 'admin',
              pageName: 'administrator',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-administrator" */ '../views/admin/administrator/form-administrator'
              ),
          },
          {
            path: 'login',
            name: 'login',
            component: () =>
              import(/* webpackChunkName: "login" */ '../views/account/login'),
            meta: {
              printReport: true,
            },
          },
          {
            path: 'forgot-password',
            name: 'ForgotPassword',
            component: () =>
              import(
                /* webpackChunkName: "forgot" */ '../views/account/forgot-password'
              ),
            meta: {
              printReport: true,
            },
          },
          {
            path: 'profile',
            name: 'ProfileAdmin',
            component: () =>
              import(
                /* webpackChunkName: "profile-admin" */ '../views/account/profile'
              ),
            meta: {},
          },
        ],
      },
      // {
      //   path: '/usr',
      //   name: 'user',
      //   meta: {},
      //   component: () =>
      //     import(/* webpackChunkName: "user" */ '../views/layouts/user'),
      //   redirect: '/',
      //   children: [
      //     {
      //       path: 'dashboard',
      //       name: 'userDashboard',
      //       meta: {},
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "user-dashboard" */ '../views/user/user-dashboard'
      //         ),
      //       children: [],
      //     },
      //   ],
      // },
    ],
  },
  {
    path: '*',
    name: 'NotFound',
    component: () =>
      import(/* webpackChunkName: "forgot" */ '../views/layouts/notfound'),
  },
];
